import { render, staticRenderFns } from "./TabellaOperazioni.vue?vue&type=template&id=03ceccbc&scoped=true&"
import script from "./TabellaOperazioni.vue?vue&type=script&lang=js&"
export * from "./TabellaOperazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ceccbc",
  null
  
)

export default component.exports